/** Number-pad input for PINs (MemberChooser). Pure, unit-tested. */
export type PinPadKey = '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | 'del';

/** A digit is added while there is room; "del" removes the last digit. */
export function pinPadPress(pin: string, key: PinPadKey, max: number): string {
  if (key === 'del') return pin.slice(0, -1);
  if (!/^\d$/.test(key) || pin.length >= max) return pin;
  return pin + key;
}
